import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  const handlePrimary = () => navigate("/contact");
  const handleSecondary = () => navigate("/services");

  return (
    <section className="cta-banner" aria-labelledby="cta-heading">
      <div className="cta-shell">
        <div className="cta-bg-orbit" aria-hidden="true" />

        <div className="cta-main">
          {/* LEFT: copy + bullets */}
          <div className="cta-copy-col">
            <p className="cta-eyebrow">Before you spend another rupee on ads</p>
            <h2 id="cta-heading">
              Turn scattered{" "}
              <span>campaigns, pages and tools into one growth plan.</span>
            </h2>
            <p className="cta-copy">
              If your marketing feels busy but not compounding, this is for you.
              In one working session we’ll map what you already have, where it’s
              leaking, and the smallest set of moves that will actually move the
              numbers in the next 30–60 days.
            </p>

            <ul className="cta-points" aria-label="What we cover on the call">
              <li>Audit of your current traffic, funnels and tracking.</li>
              <li>Simple, channel-agnostic roadmap for your next 90 days.</li>
              <li>Clear view of what to pause, fix, or double down on.</li>
            </ul>

            <div className="cta-actions">
              <button
                className="cta-btn cta-btn-primary"
                type="button"
                onClick={handlePrimary}
                aria-label="Book a strategy session"
              >
                Book a 30–45 min strategy call
              </button>
              <button
                className="cta-btn cta-btn-ghost"
                type="button"
                onClick={handleSecondary}
                aria-label="View services"
              >
                Explore services first
              </button>
            </div>

            <div className="cta-reassure">
              <span className="cta-dot" aria-hidden="true" />
              <span>
                No long pitches, no pressure. You leave with notes and a clear
                next step—even if we never work together.
              </span>
            </div>
          </div>

          {/* RIGHT: mini “what you walk away with” card */}
          <aside
            className="cta-side-card"
            aria-label="What you walk away with"
          >
            <div className="cta-side-head">
              <p className="side-label">You’ll walk away with</p>
              <p className="side-sub">
                A short written summary after the call so your team can act on
                it without re-explaining everything.
              </p>
            </div>

            <ol className="cta-list">
              <li className="cta-list-item">
                <div className="cta-list-index">01</div>
                <div className="cta-list-body">
                  <h3>Snapshot of where you are</h3>
                  <p>
                    A quick view of what’s working, what’s stuck, and which
                    numbers actually matter for your stage.
                  </p>
                </div>
              </li>
              <li className="cta-list-item">
                <div className="cta-list-index">02</div>
                <div className="cta-list-body">
                  <h3>3–5 priority moves</h3>
                  <p>
                    Concrete changes to campaigns, pages or lifecycle that you
                    can ship in the next few weeks.
                  </p>
                </div>
              </li>
              <li className="cta-list-item">
                <div className="cta-list-index">03</div>
                <div className="cta-list-body">
                  <h3>Suggested engagement options</h3>
                  <p>
                    If it makes sense to keep working together, we’ll outline a
                    simple way to start. If not, you still keep the plan.
                  </p>
                </div>
              </li>
            </ol>

            <div className="cta-footnote">
              <span className="pill">Founders & lean teams</span>
              <span className="pill">In-house marketers</span>
              <span className="pill">Revamping existing funnels</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Banner;
